/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getStructDecoder,
  getStructEncoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from '@solana/kit';

export type CosignerArg = { cosigner: Address };

export type CosignerArgArgs = CosignerArg;

export function getCosignerArgEncoder(): FixedSizeEncoder<CosignerArgArgs> {
  return getStructEncoder([['cosigner', getAddressEncoder()]]);
}

export function getCosignerArgDecoder(): FixedSizeDecoder<CosignerArg> {
  return getStructDecoder([['cosigner', getAddressDecoder()]]);
}

export function getCosignerArgCodec(): FixedSizeCodec<
  CosignerArgArgs,
  CosignerArg
> {
  return combineCodec(getCosignerArgEncoder(), getCosignerArgDecoder());
}
